export class BaseAPIError extends Error {}
